module.exports = __webpack_public_path__ + "static/media/16th_B.a8dde974.png";